export const normalizeMuslinGarmentType = (value) => String(value || '').replace(/^test_/, '').toLowerCase();

const DESIGN_OPTION_MAP = {
  jacket: {
    front_style: { key: 'jacket_style', categories: ['front_details'] },
    no_of_buttons: { key: 'button_configuration', categories: ['front_details'] },
    lapel_style: { key: 'lapel_type', categories: ['lapel_details'] },
  },
  overcoat: {
    front_style: { key: 'jacket_style', categories: ['front_details'] },
    no_of_buttons: { key: 'button_configuration', categories: ['front_details'] },
    lapel_style: { key: 'lapel_type', categories: ['lapel_details'] },
  },
  trouser: {
    front_pleat_style: { key: 'pleats', categories: ['front_details', 'pleat_details', 'pleat'] },
  },
  waistcoat: {
    front_style: { key: 'waistcoat_style', categories: ['front_details'] },
    style: { key: 'waistcoat_style', categories: ['style'] },
    no_of_buttons: { key: 'button_configuration', categories: ['front_details', 'style'] },
    neck_style: { key: 'neck_style', categories: ['front_details', 'neck_details'] },
    neck_shape: { key: 'neck_style', categories: ['style'] },
    lapel_style: { key: 'lapel_style', categories: ['front_details', 'lapel_details'] },
    lapel_details: { key: 'lapel_style', categories: ['style'] },
    hem_style: { key: 'hem_style', categories: ['front_details', 'hem_details'] },
  },
  shirt: {
    collar_style: { key: 'collar', categories: ['collar_details'] },
    cuff_type: { key: 'cuff', categories: ['cuff_details', 'sleeve_details'] },
  },
};

const DESIGN_VALUE_PRESETS = {
  single_breasted: 'Single Breasted',
  double_breasted: 'Double Breasted',
  notch: 'Notch',
  notch_lapel: 'Notch',
  peak: 'Peak',
  peak_lapel: 'Peak',
  shawl: 'Shawl',
  shawl_lapel: 'Shawl',
  flat_front: 'No Pleats',
  no_pleat: 'No Pleats',
  no_pleats: 'No Pleats',
  single_pleat: 'Single Pleat',
  double_pleat: 'Double Pleat',
  v_neck: 'V-Neck',
  u_neck: 'U-Neck',
  v_shape: 'V',
  v_shaped: 'V',
  v_hem: 'V',
  straight_hem: 'Straight',
};

const normalizeOptionKey = (value) => String(value || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');

const normalizeDesignValue = (value) => {
  const raw = String(value || '').trim();
  const normalizedKey = normalizeOptionKey(raw);
  return DESIGN_VALUE_PRESETS[normalizedKey] || raw;
};

export const MUSLIN_DESIGN_CONFIG = {
  jacket: [
    { key: 'jacket_style', label: 'Jacket Style', options: ['Single Breasted', 'Double Breasted', 'Tailcoat'] },
    { key: 'lapel_type', label: 'Lapel Type', options: ['Notch', 'Peak', 'Shawl'] },
    { key: 'button_configuration', label: 'No of Buttons', options: ['1', '2', '3', '4', '6X2'] },
  ],
  trouser: [
    { key: 'pleats', label: 'Pleats', options: ['No Pleats', 'Single Pleat', 'Double Pleat'] },
  ],
  shirt: [
    { key: 'collar', label: 'Collar', options: [] },
    { key: 'cuff', label: 'Cuff', options: [] },
  ],
  waistcoat: [
    { key: 'waistcoat_style', label: 'Waistcoat Style', options: ['Single Breasted', 'Double Breasted'] },
    { key: 'neck_style', label: 'Neck Style', options: ['V-Neck', 'U-Neck'] },
    { key: 'lapel_style', label: 'Lapel Style', options: ['None', 'Notch', 'Peak', 'Shawl'] },
    { key: 'hem_style', label: 'Hem Style', options: ['V', 'Straight'] },
    { key: 'button_configuration', label: 'No of Buttons', options: ['4', '5', '6', '6X3'] },
  ],
  overcoat: [
    { key: 'jacket_style', label: 'Jacket Style', options: ['Single Breasted', 'Double Breasted'] },
    { key: 'lapel_type', label: 'Lapel Type', options: ['Notch', 'Peak', 'Shawl'] },
    { key: 'button_configuration', label: 'No of Buttons', options: ['2', '3', '4', '6X2'] },
  ],
};

export const getMuslinDesignConfig = (garmentType) => MUSLIN_DESIGN_CONFIG[normalizeMuslinGarmentType(garmentType)] || [];

export const formatMuslinDesignValue = (value) => String(value || '')
  .replace(/_/g, ' ')
  .trim()
  .split(' ')
  .filter(Boolean)
  .map((word) => (word.toLowerCase().startsWith('x') ? word.toUpperCase() : word.charAt(0).toUpperCase() + word.slice(1)))
  .join(' ');

export const buildMuslinTargetDesignProfile = (customizations = [], garmentType) => {
  const garmentKey = normalizeMuslinGarmentType(garmentType);
  const designProfile = {};
  const optionMap = DESIGN_OPTION_MAP[garmentKey] || {};

  (customizations || []).forEach((item) => {
    const selectedValue = String(item?.selected_value || '').trim();
    const optionKey = normalizeOptionKey(item?.option_name);
    const categoryKey = normalizeOptionKey(item?.category_name);
    const mappingRule = optionMap[optionKey] || {};
    const designKey = mappingRule.key;
    const allowedCategories = mappingRule.categories || [];

    if (designKey && selectedValue && (!allowedCategories.length || allowedCategories.includes(categoryKey))) {
      designProfile[designKey] = normalizeDesignValue(selectedValue);
    }
  });

  return designProfile;
};